/**
 * La sessione di verifica ricordata per commessa (GI-279).
 *
 * **Il problema.** La sessione viaggiava solo nell'indirizzo del banco
 * (`?session=`). Ogni scheda della commessa — Mappa, Foto, Copertura — la
 * lasciava cadere, e il ritorno sul banco trovava la «sola osservazione» con il
 * consiglio di riaprire la coda dal pool: era la navigazione stessa a togliere
 * all'operatore cio' che aveva preso.
 *
 * **La soluzione.** Si ricorda, per ogni commessa, l'ultima sessione aperta in
 * questa scheda del navigatore. La scheda «Banco» la rimette nell'indirizzo, e
 * il banco che arriva senza la ritrova da solo. `sessionStorage` e non
 * `localStorage`: la sessione e' della scheda, come lo e' sul servizio
 * (l'apertura e' idempotente per utente, scheda e commessa), e una scheda
 * chiusa non deve lasciare una sessione fantasma a quella che si apre dopo.
 *
 * Una sessione ricordata ma scaduta non fa danno: l'apertura sul servizio e'
 * idempotente e restituisce quella viva, o ne apre una nuova.
 */

const PREFIX = 'gridfly.review-session.'

function store(): Storage | null {
  try {
    return window.sessionStorage
  } catch {
    // Navigatore in modalita' privata o archivio disabilitato: si lavora come
    // prima, con la sessione nel solo indirizzo.
    return null
  }
}

/** Ricorda la sessione aperta su una commessa. */
export function rememberReviewSession(inspectionId: string, reviewSessionId: string): void {
  store()?.setItem(PREFIX + inspectionId, reviewSessionId)
}

/** La sessione ricordata per la commessa, o nulla. */
export function recallReviewSession(inspectionId: string): string | null {
  const found = store()?.getItem(PREFIX + inspectionId) ?? null
  return found === '' ? null : found
}

/** Si dimentica quando l'operatore chiude la sessione: da li' in poi il banco
 *  che si riapre e' in sola osservazione, come ha chiesto. */
export function forgetReviewSession(inspectionId: string): void {
  store()?.removeItem(PREFIX + inspectionId)
}
